<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-3">
        <presupuesto-crud />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PresupuestoCrud from "./PresupuestoCrud/PresupuestoCrud.vue";

export default {
  name: "PresupuestoManagementPage",
  components: { PresupuestoCrud },
};
</script>
